<template>
  <div id="content">
    <!-- 暂时隐藏 -->
    <div class="block"
         v-if="!isMobile || item.mobile"
         v-for="(item, index) in gameList"
         :key="index" @click="goto(index)">
      <div class="name">{{item.name}}</div>
      <div class="desc">{{item.desc}}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  #content {
    max-width: 400px;
    margin: 0 auto;
    padding: 0 20px;
    .block{
      padding: 0 10px;
      margin-bottom: 5px;
      transition: background-color 200ms;
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
      & .name{}
      & .desc{
        color: #aaa;
        font-size: 12px;
      }
    }
  }
</style>

<script>
export default {
  name: 'gameMenu',
  data () {
    return {
      isMobile: false,
      loading: false,
      gameList: [
        {
          name: "扫雷",
          path: "/minesweeper",
          desc: "经典扫雷，左键打开，右键插旗",
          mobile: true,
        },
        {
          name: "贪吃蛇",
          path: "/snake",
          desc: "贪吃蛇，WASD或方向键操控",
        },
        {
          name: "填色",
          path: "/color",
          desc: "填色使之成渐变状",
          mobile: true,
        },
        {
          name: "连连看",
          path: "/link",
          desc: "经典连连看，左键操作，无解需要刷新重来",
          mobile: true,
        },
        {
          name: "跳一跳",
          path: "/jump",
          desc: "横版跳跃游戏，WASD或方向键操控，开发中...",
        },
        {
          name: "Picross",
          path: "/picross",
          desc: "经典Picross",
          mobile: true,
        },
        {
          name: "猜数字",
          path: "/digital",
          desc: "经典猜数字游戏 - Bulls and Cows",
          mobile: true,
        },
        // {
        //   name: "狼人杀上帝助手",
        //   path: "/wolf",
        //   desc: "狼人kill专用发牌器",
        // },
        // {
        //   name: "12班去向图",
        //   path: "/graduate",
        //   desc: "110900010643",
        //   color: "#ff7381",
        //   loading: false,
        //   mobile: true,
        // },
        {
          name: "地形生成器",
          path: "/eco",
          desc: "自主研发，已搁浅",
        },
        {
          name: "css画板",
          path: "/cssDraw",
          desc: "纯css画一些东西",
          mobile: true,
        },
        {
          name: "三灾",
          path: "/tripleDisaster",
          desc: "移动端文字冒险游戏",
          mobile: true,
        },
        {
          name: "魔方",
          path: "/magicCube",
          desc: "用three.js创建的魔方游戏，支持3-5阶，自由旋转视角",
        },
        {
          name: "杠·地图编辑器",
          path: "/gangEditor",
          desc: "用three.js创建的地图编辑器",
        },
        {
          name: "杭州三杠科技有限公司",
          path: "/gangCompany",
          desc: "移动端模拟经营类游戏",
          mobile: true,
        },
        {
          name: "动物世界",
          path: "/animal",
          desc: "根据电影《动物世界》引发的一些思考",
          mobile: true,
        },
        // {
        //   name: "CTO之路",
        //   path: "/road2CTO",
        //   desc: "传统rpg类型游戏",
        //   mobile: true,
        // },
        {
          name: "里该隐合成表（已废弃）",
          path: "/cain",
          desc: "以撒的结合里该隐合成表",
        },
        {
          name: "coc工具",
          path: "/coc",
          desc: "我也不知道为啥写这个",
          mobile: true,
        },
        {
          name: "点灯游戏解密器",
          path: "/light",
          desc: "让人红温的解谜游戏",
          mobile: true,
        },
        // {
        //   name: "猜文章",
        //   path: "/guessBK",
        //   desc: "你能用最少的次数猜出文章吗？(猜出标题即可)",
        //   mobile: true,
        // },
        {
          name: "合成大无尽",
          path: "/merge",
          desc: "1+1>2",
          mobile: false,
        },
      ]
    }
  },
  mounted(){
    this.isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  },
  methods: {
    goto(index){
      if(!this.loading){
        let page = this.$router.resolve({
          path: this.gameList[index].path
        });
        window.open(page.href, '_blank');
        // 2025年11月6日 10:42:53 改为无论什么情况都新窗口打开
        // if(this.gameList[index].newTab){
        //   let page = this.$router.resolve({
        //     path: this.gameList[index].path
        //   });
        //   window.open(page.href, '_blank');
        // } else {
        //   this.gameList[index].loading = true;
        //   this.loading = true;
        //   this.$router.push(this.gameList[index].path, () => {
        //     this.gameList[index].loading = false;
        //     this.loading = false;
        //   });
        // }
      }
    }
  }
}

/**
                           _ooOoo_
                          o8888888o
                          88" . "88
                          (| -_- |)
                           O\ = /O
                       ____/`---'\____
                     .   ' \\| |// `.
                      / \\||| : |||// \
                    / _||||| -:- |||||- \
                      | | \\\ - /// | |
                    | \_| ''\---/'' | |
                     \ .-\__ `-` ___/-. /
                  ___`. .' /--.--\ `. . __
               ."" '< `.___\_<|>_/___.' >'"".
              | | : `- \`.;`\ _ /`;.`/ - ` : | |
                \ \ `-. \_ __\ /__ _/ .-` / /
        ======`-.____`-.___\_____/___.-`____.-'======
                           `=---='

        .............................................
                 佛祖保佑             永无BUG
         佛曰:
                 写字楼里写字间，写字间里程序员；
                 程序人员写程序，又拿程序换酒钱。
                 酒醒只在网上坐，酒醉还来网下眠；
                 酒醉酒醒日复日，网上网下年复年。
                 但愿老死电脑间，不愿鞠躬老板前；
                 奔驰宝马贵者趣，公交自行程序员。
                 别人笑我忒疯癫，我笑自己命太贱；
                 不见满街漂亮妹，哪个归得程序员？

 */


/**
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                                                                                    '!%%%!'                                                                                                 .
                                                                                                                               `!|%%%%%%%%%%%%|:.                                                                                           .
                                                                                                                           .;%%%%%%$$$$$$%%%%%%%%%%|;.                                                                                      .
                                                                                                                        '|%%%%%%%%%%$%%%%%%%%%%$$%%%%%|;.                                                                                   .
                                                                                                                    .;%%%%%%%%%%%%%%%%%%%%%%%%%%$$$%|!!|!'                                                                                  .
                                                                                                                 '|%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%!!!!|%|!:.                                                                                .
                                                             `':;;!||%:                                    .'!|%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%!!!!!!|%|!!!`                                                                               .
                                                         .;%%!:::::::;;;'            '|%%%%%%%%|!;::;|%$$$$$$%%%%%%%%%%%%%%%%%%%%%%%%%%%%%$%%|!!!!!!!|%%|!!!!:                                                                              .
                                                          .!$|`                  '|%%%%%%%%%%%%%%%%%$%%%%%%%%%%$%%%%%%%%%%%%%%%%%%%%%%%$%%%|!!!!!!!!!|%%%|!!!!;`                                                                            .
                                                            ;$|`            '|%%$$%%%%%%%%%%%%%%%%%%$$$%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%|!!!!!!!!!!||%%%|!!!!!!'                                                                           .
                                                             ;$|`      '!%$$$%%%%%%%%%%%%%%%%%%%%%%$$$$$$%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%!!!!!!!!!!!!!|%%%%|!!!!!!!;.                                                                         .
                                                              :%%%%%%%%|;`  .!%%%%%%%%%%%%%%%%%%%%%$$$$$$$$%%%%%$%%%$$%%$%%%%%$%$$$$%!!!!!!!!!!!!!!!|%%%%%|!!!!!!!!'                                                                        .
                                                                           .!%%%%%%%%%%%%$$%%%%%%%%$$$$$$$$$%%%%%%%%%%%%%%!:::::::;;::;!!!!!!!!!!!!|%%%%%%|!!!!!!!!!:.                                                                      .
                                                                          `!%%$$$$$$$$$$$$$$%%%%%%$$$$$$$$$%%%%%%%%%%%%%|!!;;;;;::::::::::!!!!!!!!!|%%%%%%|!!!!!!!!!!;`                                                                     .
                                                                        '|%%%$$$$$$$$$$$$$$$$%%%%%$$$$$$%%%%%%%%%%%%%%|!!!;;;;;;;;:::::::::::;!!!!||%%%%%%%|!!!!!!!!!!!:                                                                    .
                                                                     .!%|||%%%%%$$$$$$$$$$$$$$%%%%$$$$%%%%%%%%%%%%%%|!!!!!;;;;;;;;;;;::::::::::::!|%%%%%%%%|!!!!!!!!!|%|'                                                                   .
                                                                   `|%|||||%%%%%%%$$$$$$$$$$$$$%%%$%%%%%%%%%%%%%%%|!!!!!!;;;;;;;;;;;;;;:'''``````':;|%%%%%%|!!!!!!||%%%%!`                                                                  .
                                                                  :$$$$%||||%%%%%%%%$$$$$$$$$$$$$%%%%%%%%%%%%%%%|!!!!!!!!;;;;;;;;;;;;::;;'```````':;;;;|%%%%|!!!!|%%%%%%%;.                                                                 .
                                                                 !&$$$$$%||||%%%%%%%%%$$$$$$$$$&&&&&&$%%%%%%%%|!!!!!!!!!;;;;;;;;;;:::::;;;;'`````':;;;;;;;!%|!!|%%%%%%%%%;                                                                  .
                                                               `%&$$$$$$$$%||%%%%%%%%%%%%$$$$$&&&&&&&&&&&&$$|!!!!!!!!!!!;;;;;;;:::::::;;;;;;;'```':;;;;;;;;;!!!||%%%%%%%%:                                                                  .
                                                              :$&&$$$$$$$$$$%|%%%%%%%%%%%%%$&&&&&&&&&&&&%'      `;!!!!!;;;;:::::::::::;;;;;;;;;'`':;;;;!%$$%||!;;;;;;;;!!:.                                                                 .
                                                            .!&&&$$$$$$$$$$$$%%%%%%%%%%%%%%$&&&&&&&&$!.              `:;::::::::::::::;;;;;;;;;;::;|$$$$$$%|||!!;;;;;;'`';|%%%%|:.                                                          .
                                                           `|&&&&$$$$$$$$$$$$$$%%%%%%%%%%%%%$&&&&%'                  '!!||||||!!!;;:::;;:;!|%$&&&;      .;|||||!;;:`````:|||||:                                                             .
                                                          :%$%%%!'`.            `!|||||%%%%%$$!.                    ';;!||||||||||!;` :$&&&&&&&&;      `!||||||!;:''````;||||||!`                                                           .
                                                        .!$$$$!.                  :|||||||%%%%:                    ';;;!|||!!!!:.     '|%$&&&&&!      '|||||||!;;;;:::;'`;||||||||;`                                                        .
                                                       `|$$$%:                     `!|%%%%%%%%%|!`                ';;;;;!!|;.         `|%%%$&&!.     ;||||||!;;;;;;;;:`      :!%%%%%%%%!'                                                   .
                                                      :$$$$|`                        .;%%%%%%%%|||!:             ';;;;;;|%;      .:'  `!%%%%%!.      '||||!;;;;;;;;:'                                                                       .
                                                    .!$$$$:                              `!%%%%%|||||;.          `!!!!;;!:      :$&$||%%%%%|'         `!!;;:'.                                                                              .
                                                   '%$$$;                                    '|%%||||%$|`         :!!!|%|`    `%&&$%%%%%%%;.                                                                                                .
                                                  :$$$$:                                         :%&&&&&$:        :$$$$$$!`  :%&&$%%%%%%|'                                                                                                  .
                                                 ;&&&&&&;                                         :$&&&&&&!.     .!$$$$$$$!.        `;|;                                                                                                    .
                                                  !&&&&&&;                                         :|||||||!`    '%$$$$$$$$;                                                                                                                .
                                                  .!&&&&&&!                                                              .`'.                                                                                                               .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                '`      !##|    .'.           !#&:       :&#|.            .%#&:    .:;`    ';:.         ;@#!     .%##!                                                                      .
                                                                '$#$'   !##|   `%@#|.       .|#@|!&&&&&&&@##@&&&&&&&!.    .%#&:    ;@#@&$$&@#@:         ;@#!     !@#|.     `%@|.                                                            .
                                                                 .%##|  !@#|  .|#&:        :&@|.         !#@;             .%@&:    ;##|   `%#&:         ;@#!    ;@#$!!!!!!!|&@$`                                                            .
                                                              `:' .|%`  !##| .|$`  :!:   '$$'  .  ;@#@@@@@#@@@@@@@@!   :||%@#@$||!`;@#|   `%#@:     `;;|&##%;;'!@@;        `$#$`                                                            .
                                                             `%#@$%%%%%%%%%%%%%%%%$@#&'      `%#@!;@@; ;@$`.|#! '&#!      !##&:    ;@#|   `%#@:        ;@##!  ;@!  !@$'    '$#%`                                                            .
                                                             `%#&:                `$#&'     `%#@: :@@; ;@$`.|@! '&#!     '$#@@$'   ;##|   `%#@:       '$@##@!.    :&#$`    '$#%`                                                            .
                                                             `%#&:  ;@@$||||$@#!  `$@&'    '$##!  ;@#&%%%%%%%%%%$@#!     |##@&%&@; !##!   `%#@:       |#@##||#$` `$#%`     '$#%`                                                            .
                                                             `%#&:  !#@;    :@#!  `$@&'   ;@##@!                        ;@&&#&:;@%'|#@;   `%#@:      ;@|!@#!'$&:.%@! .|&:  '&#%`                                                            .
                                                             `%#&:  !#@;    :@#!  `$@&' .||.;@#!.:!!!!!!!$$!!!;;!;;;:. '&|'%#&:   `%#$'   `%#@:     '&! ;@#!   .%%`  .:$#%`:&#%.                                                            .
                                                             `%#&:  !#@;    :@#!  `$#&'     ;@#!   ``.%@|`;@@|. '`    '%; .%#&:   ;@#!    `%#@:    '|:  ;@#!  '&####@%:;&#|;&#|.                                                            .
                                                             `%#&:  !##%::::|@#!  `$#&'     ;@#!  !@;`%#%` :&;  `%#&:     .%#&:  '$#|.    `%#@:         ;@#!            '' :&#|.                                                            .
                                                             `%#&:                '$#&'     ;##!:&#&'`%#$:       .%#$'    .%@&: `%@!      .|##$!;;:.    ;@#;               !@#!                                                             .
                                                             `%#&:             '$##@@%`     ;@#! ';`  :&#######$`         .%#&:'$$'        '&#@###%.    ;@#!           :&####&:                                                             .
                                                              '!:.              `;;:.       `;;`                           :|;`:`                       .;;`            .;!:.                                                               .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                                  :%$|'  '!`   '!` :!.   '!` '!`        .!'    '|'   .!: .!%%%|'    '|$%:                                                                                   .
                                                                                '$;      ;$'   ;$' !#&:  :$: ;$'        |@$'   :&@!  `%! `$;   |$'`%!                                                                                       .
                                                                                `%&!'    ;$'   ;$' !%|&! :$: ;$'       ;$'!%`  :$|%%``%! `$;   '$:.|&!'.                                                                                    .
                                                                                    .;&! ;$'   ;$' !%``%%|$: ;$'      '$; .%!  :$: !&|%! `$;   '$:    .;$|.                                                                                 .
                                                                                 `.  .%|.'$!  `%%. !%`  !@&: ;$'     `%$|!!%&; :$:  :&#! `$;  .|$` `.   |%`                                                                                 .
                                                                                 `;||!`    '!|;`   :;.   '!` '|||||!':;.    '!.`;`   .;' .;|||!`   .;||!`                                                                                   .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .
                                                                                                                                                                                                                                            .

 */

/**
 * ┌───┐   ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┐
 * │Esc│   │ F1│ F2│ F3│ F4│ │ F5│ F6│ F7│ F8│ │ F9│F10│F11│F12│ │P/S│S L│P/B│  ┌┐    ┌┐    ┌┐
 * └───┘   └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┘  └┘    └┘    └┘
 * ┌───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───────┐ ┌───┬───┬───┐ ┌───┬───┬───┬───┐
 * │~ `│! 1│@ 2│# 3│$ 4│% 5│^ 6│& 7│* 8│( 9│) 0│_ -│+ =│ BacSp │ │Ins│Hom│PUp│ │N L│ / │ * │ - │
 * ├───┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─────┤ ├───┼───┼───┤ ├───┼───┼───┼───┤
 * │ Tab │ Q │ W │ E │ R │ T │ Y │ U │ I │ O │ P │{ [│} ]│ | \ │ │Del│End│PDn│ │ 7 │ 8 │ 9 │   │
 * ├─────┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴─────┤ └───┴───┴───┘ ├───┼───┼───┤ + │
 * │ Caps │ A │ S │ D │ F │ G │ H │ J │ K │ L │: ;│" '│ Enter  │               │ 4 │ 5 │ 6 │   │
 * ├──────┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴────────┤     ┌───┐     ├───┼───┼───┼───┤
 * │ Shift  │ Z │ X │ C │ V │ B │ N │ M │< ,│> .│? /│  Shift   │     │ ↑ │     │ 1 │ 2 │ 3 │   │
 * ├─────┬──┴─┬─┴──┬┴───┴───┴───┴───┴───┴──┬┴───┼───┴┬────┬────┤ ┌───┼───┼───┐ ├───┴───┼───┤ E││
 * │ Ctrl│ Fn │Alt │         Space         │ Alt│Win │-3- │Ctrl│ │ ← │ ↓ │ → │ │   0   │ . │←─┘│
 * └─────┴────┴────┴───────────────────────┴────┴────┴────┴────┘ └───┴───┴───┘ └───────┴───┴───┘
 */


/**
 *
 *   █████▒█    ██  ▄████▄   ██ ▄█▀       ██████╗ ██╗   ██╗ ██████╗
 * ▓██   ▒ ██  ▓██▒▒██▀ ▀█   ██▄█▒        ██╔══██╗██║   ██║██╔════╝
 * ▒████ ░▓██  ▒██░▒▓█    ▄ ▓███▄░        ██████╔╝██║   ██║██║  ███╗
 * ░▓█▒  ░▓▓█  ░██░▒▓▓▄ ▄██▒▓██ █▄        ██╔══██╗██║   ██║██║   ██║
 * ░▒█░   ▒▒█████▓ ▒ ▓███▀ ░▒██▒ █▄       ██████╔╝╚██████╔╝╚██████╔╝
 *  ▒ ░   ░▒▓▒ ▒ ▒ ░ ░▒ ▒  ░▒ ▒▒ ▓▒       ╚═════╝  ╚═════╝  ╚═════╝
 *  ░     ░░▒░ ░ ░   ░  ▒   ░ ░▒ ▒░
 *  ░ ░    ░░░ ░ ░ ░        ░ ░░ ░
 *           ░     ░ ░      ░  ░
 */

</script>



// WEBPACK FOOTER //
// src/components/gameMenu.vue